import { createAction } from "redux-actions";
import types from "./types";

export const getList = createAction(types.GET_LIST);
export const getListSuccess = createAction(types.GET_LIST_SUCCESS);
export const setFilters = createAction(types.SET_FILTERS);
export const setPagination = createAction(types.SET_PAGINATION);
export const getListError = createAction(types.GET_LIST_ERROR);



// WEBPACK FOOTER //
// ./src/infraMonitor/actions.js